import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {TagsFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {IRule} from "@/views/editor/service/types";

export abstract class AAtmosphere extends ABusiness {
    readonly icon = () => h(TagsFilled, {style: 'color:#22c55e'});
    title = '氛围';
    description = '';

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        return []
    }

    implementations(status: EActivityStatus): RadioGroupChildOption[] {
        return {active: [], preheating: [], finished: []}[status]
    }

    setRules(origin: string, rules: IRule[]): void {
        //
    }
}